import React, { useCallback, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { ConsignmentItemFormHandle } from '../../form/transit/consignment-item/components/TransitConsignmentItemForm'
import { notifyConsignmentItemSaveResult } from './notifyConsignmentItemSaveResult'

interface ConsignmentItemDrawerProps {
  isOpen: boolean
  houseConsignmentSequenceNumber: number
  consignmentItemSequenceNumber: number
  formRef: React.RefObject<ConsignmentItemFormHandle | null>
  onClose: () => void
  children: React.ReactNode
}

function ConsignmentItemDrawer({
  isOpen,
  houseConsignmentSequenceNumber,
  consignmentItemSequenceNumber,
  formRef,
  onClose,
  children,
}: Readonly<ConsignmentItemDrawerProps>) {
  const { t } = useTranslation()
  const [isSaving, setIsSaving] = useState(false)

  const saveAndClose = useCallback(async () => {
    if (formRef.current?.isDirty()) {
      setIsSaving(true)
      try {
        const result = await formRef.current.save()
        notifyConsignmentItemSaveResult(result, t)
        if (!result.success) return
      } finally {
        setIsSaving(false)
      }
    }
    onClose()
  }, [formRef, onClose, t])

  return (
    <Offcanvas
      className="extra-wide ci-drawer"
      show={isOpen}
      onHide={saveAndClose}
      placement="end"
    >
      <Offcanvas.Header
        className="border-bottom"
        closeButton
      >
        <h1 className="fs-4 fw-normal mb-0 text-dark">
          {t('declaration.p5.consignmentItemDrawer.title', {
            houseConsignmentSequenceNumber,
            consignmentItemSequenceNumber,
          })}
        </h1>
      </Offcanvas.Header>

      <Offcanvas.Body key="data-body" className="p-0">
        <div className="container-fluid ci-drawer__body">
          {children}
        </div>
      </Offcanvas.Body>

      <div className="ci-drawer__footer">
        <Button
          variant="dark"
          onClick={saveAndClose}
          disabled={isSaving}
        >
          {t('buttons.done')}
        </Button>
      </div>
    </Offcanvas>
  )
}

export default ConsignmentItemDrawer
